var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoEdge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 44,
    viewBox: "0 0 227 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3225_211936)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 43,
    width: 31,
    height: 1,
    transform: "rotate(-90 0 43)",
    fill: "#07070F",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 43,
    width: 31,
    height: 1,
    transform: "rotate(-90 34 43)",
    fill: "#07070F",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.015625 12C0.015625 10.8954 0.911056 10 2.01562 10L33.0156 10C34.1202 10 35.0156 10.8954 35.0156 12L0.015625 12Z",
    fill: "#1E7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0156 12C67.0156 10.8954 67.9111 10 69.0156 10L99.0156 10C100.12 10 101.016 10.8954 101.016 12L67.0156 12Z",
    fill: "#1E7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.016 12C133.016 10.8954 133.911 10 135.016 10L165.016 10C166.12 10 167.016 10.8954 167.016 12L133.016 12Z",
    fill: "#1E7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.016 12C199.016 10.8954 199.911 10 201.016 10L226.016 10C226.568 10 227.016 10.4477 227.016 11C227.016 11.5523 226.568 12 226.016 12L199.016 12Z",
    fill: "#1E7AFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 43,
    width: 34,
    height: 1,
    fill: "#07070F",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 43,
    width: 34,
    height: 1,
    fill: "#07070F",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 43,
    width: 34,
    height: 1,
    fill: "#07070F",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 43,
    width: 31,
    height: 1,
    transform: "rotate(-90 67 43)",
    fill: "#07070F",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 43,
    width: 31,
    height: 1,
    transform: "rotate(-90 100 43)",
    fill: "#07070F",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 43,
    width: 31,
    height: 1,
    transform: "rotate(-90 133 43)",
    fill: "#07070F",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 43,
    width: 31,
    height: 1,
    transform: "rotate(-90 166 43)",
    fill: "#07070F",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 43,
    width: 31,
    height: 1,
    transform: "rotate(-90 199 43)",
    fill: "#07070F",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0763 12.0607C24.6621 11.4749 24.6621 10.5251 24.0763 9.93934L14.5303 0.393398C13.9446 -0.192389 12.9948 -0.192389 12.409 0.393398C11.8232 0.979185 11.8232 1.92893 12.409 2.51472L20.8943 11L12.409 19.4853C11.8232 20.0711 11.8232 21.0208 12.409 21.6066C12.9948 22.1924 13.9446 22.1924 14.5303 21.6066L24.0763 12.0607ZM23.0156 9.5L20.0156 9.5L20.0156 12.5L23.0156 12.5L23.0156 9.5Z",
    fill: "#1E7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0763 12.0607C90.6621 11.4749 90.6621 10.5251 90.0763 9.93934L80.5303 0.393398C79.9446 -0.192389 78.9948 -0.192389 78.409 0.393398C77.8232 0.979185 77.8232 1.92893 78.409 2.51472L86.8943 11L78.409 19.4853C77.8232 20.0711 77.8232 21.0208 78.409 21.6066C78.9948 22.1924 79.9446 22.1924 80.5303 21.6066L90.0763 12.0607ZM89.0156 9.5L86.0156 9.5L86.0156 12.5L89.0156 12.5L89.0156 9.5Z",
    fill: "#1E7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.076 12.0607C156.662 11.4749 156.662 10.5251 156.076 9.93934L146.53 0.393398C145.945 -0.192389 144.995 -0.192389 144.409 0.393398C143.823 0.979185 143.823 1.92893 144.409 2.51472L152.894 11L144.409 19.4853C143.823 20.0711 143.823 21.0208 144.409 21.6066C144.995 22.1924 145.945 22.1924 146.53 21.6066L156.076 12.0607ZM155.016 9.5L152.016 9.5L152.016 12.5L155.016 12.5L155.016 9.5Z",
    fill: "#1E7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.076 12.0607C219.662 11.4749 219.662 10.5251 219.076 9.93934L209.53 0.393398C208.945 -0.192389 207.995 -0.192389 207.409 0.393398C206.823 0.979185 206.823 1.92893 207.409 2.51472L215.894 11L207.409 19.4853C206.823 20.0711 206.823 21.0208 207.409 21.6066C207.995 22.1924 208.945 22.1924 209.53 21.6066L219.076 12.0607ZM218.016 9.5L215.016 9.5L215.016 12.5L218.016 12.5L218.016 9.5Z",
    fill: "#1E7AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3225_211936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 227,
    height: 44,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEdge);
export default __webpack_public_path__ + "static/media/no-edge.290e7f94.svg";
export { ForwardRef as ReactComponent };